import ToastContext from 'contexts/Toast/ToastContext';
import React from 'react';
import { SetToastFunc } from 'types/toast';

const useToast = () => {
	const addToast = React.useContext(ToastContext) as SetToastFunc;

	return {
		addToast
	};
};

export default useToast;
